import Grid from "@mui/material/Grid";

import MDBox from "@vendor/components/MDBox";
import PageLayout from "@vendor/examples/LayoutContainers/PageLayout";

// Layout con portada para el registro. Solo lo usa el módulo auth.
import type { ReactNode } from "react";
import type { Theme } from "@mui/material/styles";

export interface CoverLayoutProps {
  coverHeight?: string;
  image: string;
  children: ReactNode;
}

export const CoverLayout = ({ coverHeight = "35vh", image, children }: CoverLayoutProps) => {
  return (
    <PageLayout>
      <MDBox
        width="calc(100% - 2rem)"
        minHeight={coverHeight}
        borderRadius="xl"
        mx={2}
        my={2}
        pt={6}
        pb={28}
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }: Theme) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.4),
              rgba(gradients.dark.state, 0.4)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox mt={{ xs: -20, lg: -18 }} px={1} width="calc(100% - 2rem)" mx="auto">
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid
            size={{
              xs: 11,
              sm: 9,
              md: 5,
              lg: 4,
              xl: 3,
            }}
          >
            {children}
          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
};
